import { ca } from '@cian/analytics';

export const trackOpenOfferNote = (id: number | undefined, position: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Click',
    action: 'open',
    label: 'comment',
    products: [
      {
        id,
        offerType: 'offer',
        position: position + 1,
      },
    ],
  });
};
